import { localization } from "../localizationManager";

export var norwegianStrings = {
  groupButton: "Grupper",
  ungroupButton: "Opphev gruppering",
  selectButton: "Velg",
  hideColumn: "Skjul kolonne",
  showColumn: "Vis kolonne",
  makePrivateColumn: "Gjør kolonne privat",
  makePublicColumn: "Gjør kolonne offentlig",
  moveToDetail: "Flytt til detaljert visning",
  showAsColumn: "Vis som kolonne",
  filterPlaceholder: "Søk...",
  removeRows: "Fjern rader",
  showLabel: "Vis",
  entriesLabel: "oppføringer",
  visualizer_text: "Tabellvisning",
  visualizer_wordcloud: "Ordsky",
  chartType_bar: "Stolpediagram",
  chartType_stackedbar: "Stablet stolpediagram",
  chartType_doughnut: "Hjuldiagram",
  chartType_pie: "Sektordiagram",
  chartType_scatter: "Punktdiagram",
  chartType_gauge: "Målediagram",
  chartType_bullet: "Kulediagram",
  hideButton: "Skjul",
  makePrivateButton: "Gjør privat",
  makePublicButton: "Gjør offentlig",
  showButton: "Vis",
  resetFilter: "Nullstill filter",
  changeLocale: "Bytt språk",
  clearButton: "Tøm",
  addElement: "Velg spørsmål...",
  defaultOrder: "Standard",
  ascOrder: "Stigende",
  descOrder: "Synkende",
  showMinorColumns: "Vis mindre kolonner",
  otherCommentTitle: "Annet og kommentarer",
  showPercentages: "Vis prosenter",
  hidePercentages: "Skjul prosenter",
};

localization.locales["no"] = norwegianStrings;
localization.localeNames["no"] = "Norwegian";
